'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createHashHistory');
module.exports = require('./index.js').createHashHistory;



//////////////////
// WEBPACK FOOTER
// ./~/history/createHashHistory.js
// module id = 1301
// module chunks = 4